import { EVENT_STATS } from 'queries/stats';
import { makeApolloClient, logError } from '../util';
import { FETCH_EVENT_STATS } from './actionTypes';

const fetchEventStats = (eventID, stats, from = '') => ({
	type: FETCH_EVENT_STATS,
	from,
	eventID,
	stats,
});

export const thunkFetchEventStats = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { stats } = await client.request(EVENT_STATS, {
			event_id: eventID,
		});
		// keyed by the requested ID, since an event with no stats row yet comes back with event_id 0
		dispatch(fetchEventStats(eventID, stats, from));
	} catch (error) {
		logError(error, 'stats.actions.thunkFetchEventStats');
	}
};
